export default __webpack_public_path__ + "static/img/aw-2023.9620ac3.jpg";